import React from 'react';
import { Section } from '../../types/Section';
import { SectionContainer } from './SectionContainer';

interface TextSectionProps {
    section: Section;
}

export const TextSection: React.FC<TextSectionProps> = ({ section }) => {
    // For text sections, we only render the content/details without a title
    // The content itself can contain headings and formatting via TinyMCE
    return (
        <>
            <style>
                {`
                    .tinymce-content {
                        line-height: 1.6;
                        color: inherit;
                    }
                    .tinymce-content h1:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content h1 {
                        font-size: 2.5rem !important;
                        font-weight: 700 !important;
                        margin-top: 2rem !important;
                        margin-bottom: 1rem !important;
                        line-height: 1.2 !important;
                    }
                    .tinymce-content h2:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content h2 {
                        font-size: 2rem !important;
                        font-weight: 600 !important;
                        margin-top: 1.75rem !important;
                        margin-bottom: 0.75rem !important;
                        line-height: 1.3 !important;
                    }
                    .tinymce-content h3:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content h3 {
                        font-size: 1.5rem !important;
                        font-weight: 600 !important;
                        margin-top: 1.5rem !important;
                        margin-bottom: 0.5rem !important;
                        line-height: 1.4 !important;
                    }
                    .tinymce-content h4:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content h4 {
                        font-size: 1.25rem !important;
                        font-weight: 600 !important;
                        margin-top: 1.25rem !important;
                        margin-bottom: 0.5rem !important;
                        line-height: 1.4 !important;
                    }
                    .tinymce-content h5:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content h5 {
                        font-size: 1.125rem !important;
                        font-weight: 600 !important;
                        margin-top: 1.25rem !important;
                        margin-bottom: 0.5rem !important;
                        line-height: 1.4 !important;
                    }
                    .tinymce-content h6:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content h6 {
                        font-size: 1rem !important;
                        font-weight: 600 !important;
                        margin-top: 1.25rem !important;
                        margin-bottom: 0.5rem !important;
                        line-height: 1.4 !important;
                    }
                    .tinymce-content p:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content p {
                        font-size: 1rem;
                        margin-top: 0.5rem;
                        margin-bottom: 0.5rem;
                    }
                    .tinymce-content ul,
                    .tinymce-content ol {
                        margin-top: 0.5rem;
                        margin-bottom: 0.5rem;
                        padding-left: 1.5rem;
                    }
                    .tinymce-content li:not([style*="color"]) {
                        color: inherit;
                    }
                    .tinymce-content li {
                        margin-top: 0.25rem;
                        margin-bottom: 0.25rem;
                    }
                    .tinymce-content strong,
                    .tinymce-content b {
                        font-weight: 600 !important;
                    }
                    .tinymce-content em,
                    .tinymce-content i {
                        font-style: italic !important;
                    }
                    .tinymce-content blockquote {
                        border-left: 4px solid #e5e7eb;
                        padding-left: 1rem;
                        margin-left: 0;
                        margin-right: 0;
                        font-style: italic;
                        color: #6b7280;
                    }
                    .tinymce-content blockquote[style*="color"] {
                        color: inherit !important;
                    }
                    /* Preserve all inline styles from TinyMCE */
                    .tinymce-content span[style] {
                        /* Spans with inline styles should keep their styles */
                    }
                    /* Override color inheritance for elements with explicit color styles */
                    .tinymce-content [style*="color:"] {
                        /* Elements with inline color styles take precedence */
                    }
                    /* Media alignment styles */
                    .tinymce-content .media-center {
                        margin-left: auto;
                        margin-right: auto;
                        display: block;
                    }
                    .tinymce-content .media-float-left {
                        float: left;
                        margin-right: 20px;
                        margin-bottom: 10px;
                    }
                    .tinymce-content .media-float-right {
                        float: right;
                        margin-left: 20px;
                        margin-bottom: 10px;
                    }
                    .tinymce-content img {
                        max-width: 100%;
                        height: auto;
                    }
                `}
            </style>
            <SectionContainer section={section}>
                <div
                    className="tinymce-content max-w-none"
                    dangerouslySetInnerHTML={{ __html: section.content || '' }}
                />
            </SectionContainer>
        </>
    );
};
